import {
  MessageCircle,
  ListChecks,
  ClipboardCheck,
  Eye,
} from 'lucide-react';
import { siteData } from '../../data/mock';
import { useInView } from '../../hooks/useInView';

const iconMap = {
  MessageCircle,
  ListChecks,
  ClipboardCheck,
  Eye,
};

export const PositioningSection = () => {
  const { positioning } = siteData;
  const [ref, isInView] = useInView();

  return (
    <section className="py-[90px] lg:py-[110px] bg-white">
      <div
        ref={ref}
        className={`max-w-[1200px] mx-auto px-6 lg:px-8 ${
          isInView ? 'animate-fade-in-up' : 'opacity-0'
        }`}
      >
        <div className="max-w-[680px]">
          <h2 className="font-heading text-[1.85rem] lg:text-[2.5rem] font-bold text-stone-900 leading-[1.15] tracking-[-0.01em]">
            {positioning.headline}
          </h2>

          <p className="mt-5 text-[1.05rem] text-stone-500 leading-[1.7]">
            {positioning.intro}
          </p>

          <p className="mt-3 text-[0.95rem] text-stone-400 leading-[1.7]">
            {positioning.detail}
          </p>

          {positioning.trust && (
            <p className="mt-5 text-[0.85rem] text-[#2d6a5a] font-medium tracking-wide">
              {positioning.trust}
            </p>
          )}
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-5 lg:gap-6">
          {positioning.benefits.map((benefit, index) => {
            const Icon = iconMap[benefit.icon];
            return (
              <div
                key={index}
                className="group flex items-start gap-4 p-6 rounded-2xl border border-stone-100 hover:border-[#2d6a5a]/15 hover:shadow-[0_2px_12px_rgba(0,0,0,0.03)]"
                style={{ transition: 'border-color 0.3s, box-shadow 0.3s' }}
              >
                <div
                  className="flex-shrink-0 w-10 h-10 rounded-xl bg-[#edf5f2] flex items-center justify-center group-hover:bg-[#2d6a5a]/10"
                  style={{ transition: 'background-color 0.3s' }}
                >
                  {Icon && <Icon size={19} className="text-[#2d6a5a]" />}
                </div>
                <div>
                  <h3 className="font-heading text-[0.95rem] font-semibold text-stone-900">
                    {benefit.title}
                  </h3>
                  <p className="mt-1 text-[0.85rem] text-stone-500 leading-relaxed">
                    {benefit.desc}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
